// extracted by mini-css-extract-plugin
export default {"projectItem":"ProjectItem-module__projectItem___T3Fkb"};